/* globals google */
var base = require('base/storeLocator/storeLocator');
var geocode = require('./geocode');
const { isEmpty } = require('../utilities/type');
const getBaseConfig = require('../common/getBaseConfig');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 * @param {Object} searchOriginLatLng Coord that is the origin of the radius
 * used for stores search
 */
function maps(searchOriginLatLng) {
    var map;
    var infowindow = new google.maps.InfoWindow();

    var center = searchOriginLatLng
        ? new google.maps.LatLng(searchOriginLatLng.lat, searchOriginLatLng.lng)
        : new google.maps.LatLng(37.09024, -95.712891); // Init U.S. Map in the center of the viewport

    var mapOptions = {
        scrollwheel: false,
        zoom: 4,
        center: center,
        styles: [
            {
                featureType: 'landscape',
                elementType: 'labels',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'transit',
                elementType: 'labels',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'water',
                elementType: 'labels',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'road',
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                stylers: [
                    {
                        hue: '#00aaff'
                    },
                    {
                        saturation: -100
                    },
                    {
                        gamma: 2.15
                    },
                    {
                        lightness: 12
                    }
                ]
            },
            {
                featureType: 'road',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        visibility: 'on'
                    },
                    {
                        lightness: 24
                    }
                ]
            },
            {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [
                    {
                        lightness: 57
                    }
                ]
            }
        ]
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var locations = $('.map-canvas').attr('data-locations');

    locations = JSON.parse(locations);

    var bounds = new google.maps.LatLngBounds();
    var markerImg;

    var shippingForm = document.querySelector('.shipping-form');
    var droppointSelected = shippingForm
        ?.querySelector(':checked', '.shipping-method-list')
        ?.dataset.droppoint === 'true' || false;
    var dropoffSelected = document.getElementById('rma-return-method-form')
        ?.querySelector('.shipping-method-block .form-check-input:checked')
        ?.dataset.pickup === 'true' || false;

    // Choose map icon depending on selected Shipping method
    if ((droppointSelected || dropoffSelected)
        && $('.placemap-image-path--droppoint')
    ) {
        markerImg = $('.placemap-image-path--droppoint').val();
    } else if ($('.placemap-image-path')) {
        markerImg = $('.placemap-image-path').val();
    } else {
        // Customized google map marker icon with svg format
        markerImg = {
            path: 'M15.068 2.182v7.462h2.23c2.152 0 3.828-1.556 3.828-3.708 0-2.168-1.598-3.754-3.828-3.754h-2.23zM13.09.39h4.192c3.45 0 5.95 2.31 5.95 5.514 0 3.158-2.548 5.53-5.95 5.53H13.09V.39zM3.712 7.727h3.384l-1.69-3.8-1.694 3.8zm4.082 1.556h-4.78L2.05 11.48H-.006L5.216.345h.442l5.22 11.136H8.774l-.98-2.198zM9.119 13.895L-.005 13.895-.005 15.657 10.891 15.657zM22.222 13.895L13.098 13.895 13.098 15.657 23.994 15.657z',
            fillColor: '#000',
            fillOpacity: 1,
            scale: 1.1,
            anchor: new google.maps.Point(13, 30),
            labelOrigin: new google.maps.Point(12, 12)
        };
    }

    Object.keys(locations).forEach(function (key) {
        var item = locations[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: markerImg
        });

        marker.addListener('click', function () {
            infowindow.setOptions({
                content: item.infoWindowHtml
            });
            infowindow.open(map, marker);
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (locations && locations.length !== 0) {
        if (searchOriginLatLng) { // If exists an origin of the stores results
            bounds.extend(center);
        }
        map.fitBounds(bounds);
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        var searchLocation;
        if (data.searchKey?.lat && data.searchKey?.long) {
            searchLocation = {
                lat: data.searchKey.lat,
                lng: data.searchKey.long
            };
        }
        maps(searchLocation);
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
async function search(element) {
    var dialog = element.closest('.in-store-inventory-dialog');

    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();

    // form & fields
    var $form = element.closest('.store-locator');
    var $country = $form.find('[name="country"]');

    // Country code for geocoding
    let countryCode;
    // City, ZIP code, address for geocoding
    var locationSearch = $form.find('[name="postalCode"]').val();

    var url = $form.attr('action');

    /** @type {boolean} is "/stores" page */
    const isStoreLocatorPage = !!$country.length;
    if (isStoreLocatorPage) {
        url += '&visibleInStoreFinder=true';
        let hasCountrySelected = $country.val() && $country.val() !== '';
        if (hasCountrySelected) {
            countryCode = $country.val();
        } else {
            // Error
            let errorMsg = $country.attr('data-missing-error');
            $country.siblings('.invalid-feedback').html(errorMsg);
            $country.addClass('is-invalid');
            spinner.stop();
            return false;
        }
    } else {
        // In Store Pickup
        // Use country code cause there is no select
        countryCode = $form.data('country-code');
    }

    const shouldShowAllStoresOfTheCountry = isEmpty(locationSearch);

    const location = await geocode.geocodeAddress(
        locationSearch,
        countryCode
    );

    let data;
    if (location?.lat && location?.lng) {
        var payload = {
            lat: location.lat,
            long: location.lng,
            countryCode: countryCode
        };

        if (shouldShowAllStoresOfTheCountry) {
            payload.radius = getBaseConfig().storeLocator.radius.unlimited;
        }

        data = await $.ajax({
            url: url,
            type: $form.attr('method'),
            data: payload,
            dataType: 'json'
        });
    } else {
        var countryLocation = await geocode.geocodeAddress('', countryCode);
        var searchKey;
        if (countryLocation) {
            searchKey = {
                lat: countryLocation.lat,
                long: countryLocation.lng
            };
        }
        // Data should be an empty search results and centered on country
        data = {
            searchKey: searchKey,
            locations: '[]',
            // searchKey: payload,
            stores: []
        };
    }

    spinner.stop();
    updateStoresResults(data);

    return false;
}

/**
 * Compares geolocated state data with a state select option
 * @param {Object} geolocatedState Obtained from geolocation ajax call
 * @param {Object} currentOption An option of state select
 * @param {string} countryCode Obtained from geolocation ajax call
 *
 * @returns {boolean} True if geolocated state value exist on state select
 */
function compareStateData(geolocatedState, currentOption, countryCode) {
    if (geolocatedState) {
        var formattedISOValue = currentOption.value.replace(countryCode + '-', '');

        if (currentOption.value === geolocatedState.short_name
            || formattedISOValue === geolocatedState.short_name
            || currentOption.text === geolocatedState.long_name
        ) {
            return true;
        }
    }

    return false;
}

module.exports = {
    methods: {
        compareStateData: compareStateData
    },
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
    },

    detectLocation: function () {
        if (!navigator.geolocation) {
            return false;
        }

        const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        // query geolocation stores
        const queryGeolocationStores = (position) => {
            const $detectLocationButton = $('.detect-location');
            let url = $detectLocationButton.data('action');
            const urlParams = {
                lat: position.coords.latitude,
                long: position.coords.longitude
            };

            url = appendToUrl(url, urlParams);
            $.ajax({
                url,
                type: 'get',
                dataType: 'json',
                success(data) {
                    $.spinner().stop();
                    updateStoresResults(data);
                }
            });
        };

        // on error geolocation
        const hasGeolocationError = () => {};

        if ($('.detect-location').length > 0) {
            // clicking on detect location
            $('.detect-location').on('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                $.spinner().start();

                navigator.geolocation.getCurrentPosition(
                    queryGeolocationStores,
                    hasGeolocationError,
                    options
                );
            });
        }

        // clicking on shipping method.
        $('body').on('click', '.shipping-method-list [type="radio"]', () => {
            if (this.value === 'inStorePickup') {
                navigator.geolocation.getCurrentPosition(
                    queryGeolocationStores,
                    hasGeolocationError,
                    options
                );
            }
        });

        return true;
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            search($(this));
        });

        $('#store-postal-code').on('keypress', function (e) {
            if (e.which === 13) {
                search($(this));
            }
        });
    },
    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store-input, .select-store-button', (function (e) {
            e.preventDefault();

            var storeDetailsHtml;
            if ($(this).hasClass('select-store-input')) {
                storeDetailsHtml = $(this).siblings('label').find('.store-details').html();
            } else if ($(this).hasClass('select-store-button')) {
                storeDetailsHtml = $(this).siblings('.store-details').html();
            }

            var data = {
                storeID: $(this).val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: storeDetailsHtml,
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton: base.updateSelectStoreButton
};
